<template>
  <!-- Content Header (Page header) -->
  <div style="height: 100%;width: 100%; background-color: black;position:absolute;z-index: 1000;
  left: 0;top: 0;opacity: 0.75; align-content: center;color: aliceblue;text-align: center;vertical-align: middle;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);background-position: center center;display: none;"
    id="loadingnya">
    <h1>
      <br><br><br><br><br>
      <img class="animation__shake" src="../../assets/img/logo_pu.jpg" style="height: 70px;position: center center;">
      <br><br>.. LOADING ..
    </h1>
  </div>
  <div v-if="halamanloading" style="height: 100%;width: 100%; background-color: black;position:absolute;z-index: 1000;
  left: 0;top: 0;opacity: 0.75; align-content: center;color: aliceblue;text-align: center;vertical-align: middle;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);background-position: center center;">
    <h1>
      <br><br><br><br><br>
      <img class="animation__shake" src="../../assets/img/logo_pu.jpg" style="height: 70px;position: center center;">
      <br><br>.. LOADING ..
    </h1>
  </div>
  <center>
    <div class="modal fade" id="costumModaldisclaimer" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
      aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
      style="margin: auto;">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-wrapper">
              <table class="table table table-bordered table-hover" id="tabeldata">
                <thead class="cf">
                  <tr>
                    <th style="width: 70px;">No</th>
                    <th>Balai</th>
                    <th>Pagu<br>(Rp.)</th>
                    <th>Realisasi<br>(Rp.)</th>
                    <th>Progres<br>Keuangan<br>(%)</th>
                    <th>Progres<br>Fisik<br>(%)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="total" colspan="2"> TOTAL</td>
                    <td class="totalkanan">{{ G_numFormat(totalpagu) }}</td>
                    <td class="totalkanan">{{ G_numFormat(totalrealisasi) }}</td>
                    <td class="totalkanan">{{ G_numKoma(rata2keu) }}</td>
                    <td class="totalkanan">{{ G_numKoma(rata2fisik) }}</td>
                  </tr>
                </tbody>
                <template v-for="(databalai, urutbalai) in datarekapsemua" :key="urutbalai">
                  <tbody>
                    <tr>
                      <td class="kolombalaikanan">{{ urutbalai + 1 }}</td>
                      <td class="kolombalai"><span data-toggle="tooltip"
                          title="Klik untuk lihat halaman detail progres fisik dan keuangan"
                          style="cursor: pointer;text-decoration: underline;"></span>
                        {{ SingkatanBalai(databalai.nmbalai) }}</td>
                      <td class="kolombalaikanan">{{ G_numFormat(databalai.pg) }}</td>
                      <td class="kolombalaikanan">{{ G_numFormat(databalai.rtot) }}</td>
                      <td class="kolombalaikanan">{{ G_numKoma(databalai.keuPrs) }}</td>
                      <td class="kolombalaikanan">{{ G_numKoma(databalai.fisikPrs) }}</td>
                    </tr>
                  </tbody>
                  <template v-for="(datasatker, urutsatker) in databalai.rekapPerSatkers" :key="urutsatker">
                    <tbody>
                      <tr>
                        <td class="kolomsatkerkanan">{{ urutbalai + 1 }}.{{ urutsatker + 1 }}</td>
                        <td class="kolomsatker">{{ datasatker.nmsatker }}</td>
                        <td class="kolomsatkerkanan">{{ G_numFormat(datasatker.pg) }}</td>
                        <td class="kolomsatkerkanan">{{ G_numFormat(datasatker.rtot) }}</td>
                        <td class="kolomsatkerkanan">{{ G_numKoma(datasatker.keuPrs) }}</td>
                        <td class="kolomsatkerkanan">{{ G_numKoma(datasatker.fisikPrs) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </template>
              </table>
            </div>
            <div class="col-md-12 text-justify">
              <div class="card card-pupr collapsed-card">
                <div class="card-header">
                  <h3 class="card-title">Show / Hide Kolom</h3>
                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div class="cardputih">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-2 col-6">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input custom-control-input-warning" type="checkbox"
                              id="customCheckboxKode" value="optionKode" @click="showColumnKode = !showColumnKode">
                            <label for="customCheckboxKode" class="custom-control-label">Kode</label>
                          </div>
                        </div>
                        <div class="col-lg-2 col-6">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input custom-control-input-warning" type="checkbox"
                              id="customCheckboxTV" value="optionTV" @click="showColumnTV = !showColumnTV">
                            <label for="customCheckboxTV" class="custom-control-label">Target
                              Volume</label>
                          </div>
                        </div>
                        <div class="col-lg-2 col-6">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input custom-control-input-success" type="checkbox"
                              id="customCheckboxJP" value="optionJP" @click="showColumnJP = !showColumnJP">
                            <label for="customCheckboxJP" class="custom-control-label">Jenis
                              Paket</label>
                          </div>
                        </div>
                        <div class="col-lg-2 col-6">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input custom-control-input-danger" type="checkbox"
                              id="customCheckboxMP" value="optionMP" @click="showColumnMP = !showColumnMP">
                            <label for="customCheckboxMP" class="custom-control-label">Metode
                              Pemilihan</label>
                          </div>
                        </div>
                        <div class="col-lg-2 col-6">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input custom-control-input-warning" type="checkbox"
                              id="customCheckboxKR" value="optionKR" @click="showColumnKR = !showColumnKR">
                            <label for="customCheckboxKR" class="custom-control-label">Kode Register
                            </label>
                          </div>
                        </div>
                        <div class="col-lg-2 col-6">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input custom-control-input-success" type="checkbox"
                              id="customCheckboxKPPN" value="optionKPPN" @click="showColumnKPPN = !showColumnKPPN">
                            <label for="customCheckboxKPPN" class="custom-control-label">Kode
                              KPPN</label>
                          </div>
                        </div>
                        <div class="col-lg-2 col-6">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input custom-control-input-warning" type="checkbox"
                              id="customCheckboxKB" value="optionKB" @click="showColumnKB = !showColumnKB">
                            <label for="customCheckboxKB" class="custom-control-label">Kode
                              Beban</label>
                          </div>
                        </div>

                      </div>
                      <!-- /.row -->
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.cardputih -->
                </div>
              </div>
            </div>
            <div class="table-wrapper">
              <table class="table table table-bordered table-hover" id="tabeldata">
                <thead class="cf">
                  <tr>
                    <th style="width: 70px;">No</th>
                    <th style="width: 250px;" v-if="showColumnKode">Kode</th>
                    <th style="width: 300px;">Kegiatan/Output/Paket/Sub Paket</th>
                    <th v-if="showColumnTV">Target<br>Volume</th>
                    <th style="width: 100px;">Lokasi</th>
                    <th style="width: 70px;" v-if="showColumnJP">Jenis<br>Paket</th>
                    <th v-if="showColumnMP">Metode<br>Pemilihan</th>
                    <th style="width: 70px;">Kode<br>Proyek</th>
                    <th v-if="showColumnKR">Kode<br>Register</th>
                    <th v-if="showColumnKPPN">Kode<br>KPPN</th>
                    <th v-if="showColumnKB">Kode<br>Beban</th>
                    <th>Pagu<br>(Rp.)</th>
                    <th>Realisasi<br>(Rp.)</th>
                    <th>Progres<br>Keuangan<br>(%)</th>
                    <th>Progres<br>Fisik (%)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="total"> TOTAL</td>
                    <td class="total" v-if="showColumnKode"></td>
                    <td class="total"></td>
                    <td class="total" v-if="showColumnTV"></td>
                    <td class="total"></td>
                    <td class="total" v-if="showColumnJP"></td>
                    <td class="total" v-if="showColumnMP"></td>
                    <td class="total"></td>
                    <td class="total" v-if="showColumnKR"></td>
                    <td class="total" v-if="showColumnKPPN"></td>
                    <td class="total" v-if="showColumnKB"></td>
                    <td class="totalkanan">{{ G_numFormat(totalpagu) }}</td>
                    <td class="totalkanan">{{ G_numFormat(totalrealisasi) }}</td>
                    <td class="totalkanan">{{ G_numKoma(rata2keu) }}</td>
                    <td class="totalkanan">{{ G_numKoma(rata2fisik) }}</td>
                  </tr>
                  <tr v-for="(dataparent, urutparent) in detailtabel" :key="urutparent">
                    <td style="width: 70px;" :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                      {{ dataparent.No }}</td>
                    <td style="width: 250px;" :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]" v-if="showColumnKode">
                      {{ dataparent.Kode }}</td>
                    <td style="width: 350px;" :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                      {{ dataparent.Kegiatan }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]" v-if="showColumnTV">
                      {{ dataparent.Target }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                      {{ dataparent.Lokasi }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]" v-if="showColumnJP">
                      {{ dataparent.Jenis }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]" v-if="showColumnMP">
                      {{ dataparent.MetodePilih }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]">
                      {{ dataparent.KodeProyek }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]" v-if="showColumnKR">
                      {{ dataparent.KodeRegister }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]" v-if="showColumnKPPN">
                      {{ dataparent.KodeKKPN }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutput' : 'kolomsatker'))]" v-if="showColumnKB">
                      {{ dataparent.KodeBeban }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]">
                      {{ G_numFormat(dataparent.Pagu) }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]">
                      {{ G_numFormat(dataparent.Realisasi) }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]">
                      {{ G_numKoma(dataparent.ProgresKeu) }}</td>
                    <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
    (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
      dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
        dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' : 'kolomsatkerkanan'))]">
                      {{ G_numKoma(dataparent.ProgresFisik) }}</td>
                  </tr>
                </tbody>

              </table>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Tutup</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </center>
  <div class="col-md-12 text-justify">
    &nbsp;
  </div>
  <button type="button" class="btn btn-tool" @click="lihatdatabalai()" id="tanggal" style="display: none;"><i
      class="fas fa-plus"></i></button>
  <iframe src="./maps.html" class="col-sm-12 text-center" style="height: 100vh;" frameborder="0" id="maps"
    scrolling="no" @load="loadpeta()"></iframe>
  <div class="col-md-12 text-justify">
    &nbsp;
  </div>
</template>

<script>
//import Vueaxios from "vue-axios";
import $ from 'jquery';
import axios from "axios";
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";


export default {
  data() {
    return {
      halamanloading: true,
      showColumnKode: false,
      showColumnTV: false,
      showColumnJP: false,
      showColumnMP: false,
      showColumnKR: false,
      showColumnKPPN: false,
      showColumnKB: false,
      defaultSelectedProyek: {
        code: "0",
        label: "Pilih Proyek"
      },
      kdProyekfilter: "",
      datamasterProyek: [],
      Proyek: [],
      tanggalsekarang: new Date(),
      datarekap: [],
      tanggaldata: '',
      totalpagu: '0',
      totalrealisasi: '0',
      totalrata2keu: '0',
      totalrata2fisik: '0',
      rata2keu: '0',
      rata2fisik: '0',
      datarekappusat: [],
      datarekapnonpusat: [],
      datarekapsemua: [],
      datarekapprogres: [],
      totalpaguprogres: '0',
      totalrealisasiprogres: '0',
      totalrata2keuprogres: '0',
      totalrata2fisikprogres: '0',
      rata2keuprogres: '0',
      rata2fisikprogres: '0',
      datatabel: [],
      detailtabel: [],
    }
  },
  computed: {
    computeditemsDataProyek: function () {
      return this.Proyek.filter(function (item) {
        return item.label != "TEST-Test Edit" && item.label != "Test Edit" && item.label != "TEST";
      })
    },
  },
  methods: {
    loadpeta() {
      this.halamanloading = false;
    },
    lihatdatabalai() {
      if (localStorage.getItem("pilihandata") == 'balai') {
        this.ambildataUpdate();
      }
      if (localStorage.getItem("pilihandata") == 'provinsi') {
        this.ambildataUpdateProvinsi();
      }
    },
    async ambildataUpdateProvinsi() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIRekap = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIRekap.get("progres/rekap/per-balai?tahun=" + localStorage.getItem("namatahun_lms")
        + "&proyek=" + localStorage.getItem("namaproyek_lms")
        + "&hasLoanOnly=true&hasSbsnOnly=false&includeRekapSatker=true" + "&kodeProv=" + localStorage.getItem("namakodeprovinsi_lms"))
        .then(
          Response => {
            this.datarekappusat = [];
            this.datarekapnonpusat = [];
            var pusat = [];
            var nonpusat = [];
            this.datarekap = Response.data;
            //console.log(this.datarekap);
            this.totalpagu = this.datarekap.content.reduce((a, { pg: e }) => a + e, 0);
            this.totalrealisasi = this.datarekap.content.reduce((a, { rtot: e }) => a + e, 0);
            //console.log("Total: "+this.totalpagu);
            //console.log("Total: "+this.totalrealisasi);
            this.totalrata2keu = this.datarekap.content.reduce((a, { keuPrs: e }) => a + e, 0);
            this.totalrata2fisik = this.datarekap.content.reduce((a, { fisikPrs: e }) => a + e, 0);
            const jumlahdata = this.datarekap.content.length;
            if (jumlahdata != 0) {
              this.rata2keu = this.totalrata2keu / jumlahdata;
              this.rata2fisik = this.totalrata2fisik / jumlahdata;

              var jumkeuPrs = 0;
              var jumfisikPrs = 0;
              this.datarekap.content.forEach((item) => {
                jumkeuPrs = jumkeuPrs + ((item.keuPrs * item.pg) / this.totalpagu);
                jumfisikPrs = jumfisikPrs + ((item.fisikPrs * item.pg) / this.totalpagu);
              });
              this.rata2keu = jumkeuPrs;
              this.rata2fisik = jumfisikPrs;
            }
            if (this.totalpagu == 0) {
              this.rata2keu = 0;
              this.rata2fisik = 0;
            }
            //console.log("Rata2: "+this.rata2keu );
            this.tanggaldata = this.datarekap.tanggalEmon;
            pusat = this.datarekap.content.filter((element) => ((element.nmbalai == 'PUSAT')));
            this.datarekappusat = pusat;
            nonpusat = this.datarekap.content.filter((element) => ((element.nmbalai != 'PUSAT')));
            this.datarekapnonpusat = nonpusat;
            this.datarekapnonpusat.sort((a, b) => {
              return b.pg - a.pg;
            });
            this.datarekapsemua = this.datarekappusat.concat(this.datarekapnonpusat);
            this.halamanloading = false;


            const mainAPIDetail = axios.create({
              baseURL: process.env.VUE_APP_URL_API,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            mainAPIDetail.get("progres/per-paket/nested?kodeProv=" + localStorage.getItem("namakodeprovinsi_lms") + "&proyek=" + localStorage.getItem("namaproyek_lms") + "&tahun=" + localStorage.getItem("namatahun_lms"))
              .then(
                Response => {
                  this.datarekapprogres = Response.data;
                  //console.log(this.datarekap);
                  this.totalpaguprogres = this.datarekap.content.reduce((a, { pg: e }) => a + e, 0);
                  this.totalrealisasiprogres = this.datarekap.content.reduce((a, { rtot: e }) => a + e, 0);
                  //console.log("Total: "+this.totalpagu);
                  //console.log("Total: "+this.totalrealisasi);
                  this.totalrata2keuprogres = this.datarekap.content.reduce((a, { keuPrs: e }) => a + e, 0);
                  this.totalrata2fisikprogres = this.datarekap.content.reduce((a, { fisikPrs: e }) => a + e, 0);
                  const jumlahdata = this.datarekap.content.length;
                  if (jumlahdata != 0) {
                    this.rata2keuprogres = this.totalrata2keuprogres / jumlahdata;
                    this.rata2fisikprogres = this.totalrata2fisikprogres / jumlahdata;
                    var jumkeuPrs = 0;
                    var jumfisikPrs = 0;
                    this.datarekapprogres.content.forEach((item) => {
                      jumkeuPrs = jumkeuPrs + ((item.keuPrs * item.pg) / this.totalpaguprogres);
                      jumfisikPrs = jumfisikPrs + ((item.fisikPrs * item.pg) / this.totalpaguprogres);
                    });
                    this.rata2keuprogres = jumkeuPrs;
                    this.rata2fisikprogres = jumfisikPrs;
                  }
                  if (this.totalpaguprogres == 0) {
                    this.rata2keuprogres = 0;
                    this.rata2fisikprogres = 0;
                  }
                  this.datarekapprogres.content.sort((a, b) => {
                    return a.kdbalai - b.kdbalai;
                  });
                  this.datatabel = this.datarekapprogres.content;
                  this.detailtabel = [];
                  for (let i = 0; i < this.datatabel.length; i++) {
                    if (this.datatabel[i].pg) {
                      this.detailtabel.push({
                        "No": i + 1,
                        "Kode": "",
                        "Kegiatan": this.datatabel[i].nmbalai,
                        "Target": "",
                        "Lokasi": "",
                        "Jenis": "",
                        "MetodePilih": "",
                        "KodeProyek": "",
                        "KodeRegister": "",
                        "KodeKKPN": "",
                        "KodeBeban": "",
                        "Pagu": this.datatabel[i].pg,
                        "Realisasi": this.datatabel[i].rtot,
                        "ProgresKeu": this.datatabel[i].keuPrs,
                        "ProgresFisik": this.datatabel[i].fisikPrs,
                        "Class": "kolompusat",
                      })
                      for (let z = 0; z < this.datatabel[i].childs.length; z++) {
                        if (this.datatabel[i].childs[z].pg) {
                          this.detailtabel.push({
                            "No": (i + 1) + "." + (z + 1),
                            "Kode": this.datatabel[i].childs[z].kode,
                            "Kegiatan": this.datatabel[i].childs[z].nmsatker || '',
                            "Target": "",
                            "Lokasi": "",
                            "Jenis": "",
                            "MetodePilih": "",
                            "KodeProyek": "",
                            "KodeRegister": "",
                            "KodeKKPN": "",
                            "KodeBeban": "",
                            "Pagu": this.datatabel[i].childs[z].pg || '0',
                            "Realisasi": this.datatabel[i].childs[z].rtot || '0',
                            "ProgresKeu": this.datatabel[i].childs[z].keuPrs || '0',
                            "ProgresFisik": this.datatabel[i].childs[z].fisikPrs || '0',
                            "Class": "kolomdirektorat",
                          })
                          for (let c = 0; c < this.datatabel[i].childs[z].childs.length; c++) {
                            if (this.datatabel[i].childs[z].childs[c].pg) {
                              this.detailtabel.push({
                                "No": (i + 1) + "." + (z + 1) + "." + (c + 1),
                                "Kode": this.datatabel[i].childs[z].childs[c].kode,
                                "Kegiatan": this.datatabel[i].childs[z].childs[c].nmgiat || '',
                                "Target": "",
                                "Lokasi": "",
                                "Jenis": "",
                                "MetodePilih": "",
                                "KodeProyek": "",
                                "KodeRegister": "",
                                "KodeKKPN": "",
                                "KodeBeban": "",
                                "Pagu": this.datatabel[i].childs[z].childs[c].pg || '0',
                                "Realisasi": this.datatabel[i].childs[z].childs[c].rtot || '0',
                                "ProgresKeu": this.datatabel[i].childs[z].childs[c].keuPrs || '0',
                                "ProgresFisik": this.datatabel[i].childs[z].childs[c].fisikPrs || '0',
                                "Class": "kolomkegiatan",
                              })
                              for (let x = 0; x < this.datatabel[i].childs[z].childs[c].childs.length; x++) {
                                if (this.datatabel[i].childs[z].childs[c].childs[x].pg) {
                                  this.detailtabel.push({
                                    "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1),
                                    "Kode": this.datatabel[i].childs[z].childs[c].childs[x].kode,
                                    "Kegiatan": this.datatabel[i].childs[z].childs[c].childs[x].nmoutput || '',
                                    "Target": "",
                                    "Lokasi": "",
                                    "Jenis": "",
                                    "MetodePilih": "",
                                    "KodeProyek": "",
                                    "KodeRegister": "",
                                    "KodeKKPN": "",
                                    "KodeBeban": "",
                                    "Pagu": this.datatabel[i].childs[z].childs[c].childs[x].pg || '0',
                                    "Realisasi": this.datatabel[i].childs[z].childs[c].childs[x].rtot || '0',
                                    "ProgresKeu": this.datatabel[i].childs[z].childs[c].childs[x].keuPrs || '0',
                                    "ProgresFisik": this.datatabel[i].childs[z].childs[c].childs[x].fisikPrs || '0',
                                    "Class": "kolomoutput"
                                  })
                                  for (let y = 0; y < this.datatabel[i].childs[z].childs[c].childs[x].childs.length; y++) {
                                    if (this.datatabel[i].childs[z].childs[c].childs[x].childs[y].pg) {
                                      var isitarget = this.datatabel[i].childs[z].childs[c].childs[x].childs[y].vol || '';
                                      var isivolume = this.datatabel[i].childs[z].childs[c].childs[x].childs[y].sat || '';
                                      this.detailtabel.push({
                                        "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1) + "." + (y + 1),
                                        "Kode": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].kode,
                                        "Kegiatan": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].nmpaket || '',
                                        "Target": isitarget + " " + isivolume,
                                        "Lokasi": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].nmlokasi || '',
                                        "Jenis": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].nmkategori || '',
                                        "MetodePilih": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].nmmetode || '',
                                        "KodeProyek": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].proyeks[0] || '',
                                        "KodeRegister": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].registers[0] || '',
                                        "KodeKKPN": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].kdkppns[0] || '',
                                        "KodeBeban": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].kdbebans[0] || '',
                                        "Pagu": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].pg || '0',
                                        "Realisasi": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].rtot || '0',
                                        "ProgresKeu": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].keuPrs || '0',
                                        "ProgresFisik": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].fisikPrs || '0',
                                        "Class": "kolomsatker"
                                      })
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  this.halamanloading = false;
                }
              ).catch(error => {
                console.log(error);
                this.halamanloading = false;
                //window.location.replace("/");
              });
            $('#costumModaldisclaimer').modal('show');

          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
    async ambildataUpdate() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIRekap = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIRekap.get("progres/rekap/per-balai?tahun=" + localStorage.getItem("namatahun_lms")
        + "&proyek=" + localStorage.getItem("namaproyek_lms")
        + "&hasLoanOnly=true&hasSbsnOnly=false&includeRekapSatker=true" + "&kdbalai=" + localStorage.getItem("namakodebalai_lms"))
        .then(
          Response => {
            this.datarekappusat = [];
            this.datarekapnonpusat = [];
            var pusat = [];
            var nonpusat = [];
            this.datarekap = Response.data;
            //console.log(this.datarekap);
            this.totalpagu = this.datarekap.content.reduce((a, { pg: e }) => a + e, 0);
            this.totalrealisasi = this.datarekap.content.reduce((a, { rtot: e }) => a + e, 0);
            //console.log("Total: "+this.totalpagu);
            //console.log("Total: "+this.totalrealisasi);
            this.totalrata2keu = this.datarekap.content.reduce((a, { keuPrs: e }) => a + e, 0);
            this.totalrata2fisik = this.datarekap.content.reduce((a, { fisikPrs: e }) => a + e, 0);
            const jumlahdata = this.datarekap.content.length;
            if (jumlahdata != 0) {
              this.rata2keu = this.totalrata2keu / jumlahdata;
              this.rata2fisik = this.totalrata2fisik / jumlahdata;

              var jumkeuPrs = 0;
              var jumfisikPrs = 0;
              this.datarekap.content.forEach((item) => {
                jumkeuPrs = jumkeuPrs + ((item.keuPrs * item.pg) / this.totalpagu);
                jumfisikPrs = jumfisikPrs + ((item.fisikPrs * item.pg) / this.totalpagu);
              });
              this.rata2keu = jumkeuPrs;
              this.rata2fisik = jumfisikPrs;
            }
            if (this.totalpagu == 0) {
              this.rata2keu = 0;
              this.rata2fisik = 0;
            }
            //console.log("Rata2: "+this.rata2keu );
            this.tanggaldata = this.datarekap.tanggalEmon;
            pusat = this.datarekap.content.filter((element) => ((element.nmbalai == 'PUSAT')));
            this.datarekappusat = pusat;
            nonpusat = this.datarekap.content.filter((element) => ((element.nmbalai != 'PUSAT')));
            this.datarekapnonpusat = nonpusat;
            this.datarekapnonpusat.sort((a, b) => {
              return b.pg - a.pg;
            });
            this.datarekapsemua = this.datarekappusat.concat(this.datarekapnonpusat);
            this.halamanloading = false;


            const mainAPIDetail = axios.create({
              baseURL: process.env.VUE_APP_URL_API,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            mainAPIDetail.get("progres/per-paket/nested?kdbalai=" + localStorage.getItem("namakodebalai_lms") + "&proyek=" + localStorage.getItem("namaproyek_lms") + "&tahun=" + localStorage.getItem("namatahun_lms"))
              .then(
                Response => {
                  this.datarekapprogres = Response.data;
                  //console.log(this.datarekap);
                  this.totalpaguprogres = this.datarekap.content.reduce((a, { pg: e }) => a + e, 0);
                  this.totalrealisasiprogres = this.datarekap.content.reduce((a, { rtot: e }) => a + e, 0);
                  //console.log("Total: "+this.totalpagu);
                  //console.log("Total: "+this.totalrealisasi);
                  this.totalrata2keuprogres = this.datarekap.content.reduce((a, { keuPrs: e }) => a + e, 0);
                  this.totalrata2fisikprogres = this.datarekap.content.reduce((a, { fisikPrs: e }) => a + e, 0);
                  const jumlahdata = this.datarekap.content.length;
                  if (jumlahdata != 0) {
                    this.rata2keuprogres = this.totalrata2keuprogres / jumlahdata;
                    this.rata2fisikprogres = this.totalrata2fisikprogres / jumlahdata;
                    var jumkeuPrs = 0;
                    var jumfisikPrs = 0;
                    this.datarekapprogres.content.forEach((item) => {
                      jumkeuPrs = jumkeuPrs + ((item.keuPrs * item.pg) / this.totalpaguprogres);
                      jumfisikPrs = jumfisikPrs + ((item.fisikPrs * item.pg) / this.totalpaguprogres);
                    });
                    this.rata2keuprogres = jumkeuPrs;
                    this.rata2fisikprogres = jumfisikPrs;
                  }
                  if (this.totalpaguprogres == 0) {
                    this.rata2keuprogres = 0;
                    this.rata2fisikprogres = 0;
                  }
                  this.datarekapprogres.content.sort((a, b) => {
                    return a.kdbalai - b.kdbalai;
                  });
                  this.datatabel = this.datarekapprogres.content;
                  this.detailtabel = [];
                  for (let i = 0; i < this.datatabel.length; i++) {
                    if (this.datatabel[i].pg) {
                      this.detailtabel.push({
                        "No": i + 1,
                        "Kode": "",
                        "Kegiatan": this.datatabel[i].nmbalai,
                        "Target": "",
                        "Lokasi": "",
                        "Jenis": "",
                        "MetodePilih": "",
                        "KodeProyek": "",
                        "KodeRegister": "",
                        "KodeKKPN": "",
                        "KodeBeban": "",
                        "Pagu": this.datatabel[i].pg,
                        "Realisasi": this.datatabel[i].rtot,
                        "ProgresKeu": this.datatabel[i].keuPrs,
                        "ProgresFisik": this.datatabel[i].fisikPrs,
                        "Class": "kolompusat",
                      })
                      for (let z = 0; z < this.datatabel[i].childs.length; z++) {
                        if (this.datatabel[i].childs[z].pg) {
                          this.detailtabel.push({
                            "No": (i + 1) + "." + (z + 1),
                            "Kode": this.datatabel[i].childs[z].kode,
                            "Kegiatan": this.datatabel[i].childs[z].nmsatker || '',
                            "Target": "",
                            "Lokasi": "",
                            "Jenis": "",
                            "MetodePilih": "",
                            "KodeProyek": "",
                            "KodeRegister": "",
                            "KodeKKPN": "",
                            "KodeBeban": "",
                            "Pagu": this.datatabel[i].childs[z].pg || '0',
                            "Realisasi": this.datatabel[i].childs[z].rtot || '0',
                            "ProgresKeu": this.datatabel[i].childs[z].keuPrs || '0',
                            "ProgresFisik": this.datatabel[i].childs[z].fisikPrs || '0',
                            "Class": "kolomdirektorat",
                          })
                          for (let c = 0; c < this.datatabel[i].childs[z].childs.length; c++) {
                            if (this.datatabel[i].childs[z].childs[c].pg) {
                              this.detailtabel.push({
                                "No": (i + 1) + "." + (z + 1) + "." + (c + 1),
                                "Kode": this.datatabel[i].childs[z].childs[c].kode,
                                "Kegiatan": this.datatabel[i].childs[z].childs[c].nmgiat || '',
                                "Target": "",
                                "Lokasi": "",
                                "Jenis": "",
                                "MetodePilih": "",
                                "KodeProyek": "",
                                "KodeRegister": "",
                                "KodeKKPN": "",
                                "KodeBeban": "",
                                "Pagu": this.datatabel[i].childs[z].childs[c].pg || '0',
                                "Realisasi": this.datatabel[i].childs[z].childs[c].rtot || '0',
                                "ProgresKeu": this.datatabel[i].childs[z].childs[c].keuPrs || '0',
                                "ProgresFisik": this.datatabel[i].childs[z].childs[c].fisikPrs || '0',
                                "Class": "kolomkegiatan",
                              })
                              for (let x = 0; x < this.datatabel[i].childs[z].childs[c].childs.length; x++) {
                                if (this.datatabel[i].childs[z].childs[c].childs[x].pg) {
                                  this.detailtabel.push({
                                    "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1),
                                    "Kode": this.datatabel[i].childs[z].childs[c].childs[x].kode,
                                    "Kegiatan": this.datatabel[i].childs[z].childs[c].childs[x].nmoutput || '',
                                    "Target": "",
                                    "Lokasi": "",
                                    "Jenis": "",
                                    "MetodePilih": "",
                                    "KodeProyek": "",
                                    "KodeRegister": "",
                                    "KodeKKPN": "",
                                    "KodeBeban": "",
                                    "Pagu": this.datatabel[i].childs[z].childs[c].childs[x].pg || '0',
                                    "Realisasi": this.datatabel[i].childs[z].childs[c].childs[x].rtot || '0',
                                    "ProgresKeu": this.datatabel[i].childs[z].childs[c].childs[x].keuPrs || '0',
                                    "ProgresFisik": this.datatabel[i].childs[z].childs[c].childs[x].fisikPrs || '0',
                                    "Class": "kolomoutput"
                                  })
                                  for (let y = 0; y < this.datatabel[i].childs[z].childs[c].childs[x].childs.length; y++) {
                                    if (this.datatabel[i].childs[z].childs[c].childs[x].childs[y].pg) {
                                      var isitarget = this.datatabel[i].childs[z].childs[c].childs[x].childs[y].vol || '';
                                      var isivolume = this.datatabel[i].childs[z].childs[c].childs[x].childs[y].sat || '';
                                      this.detailtabel.push({
                                        "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1) + "." + (y + 1),
                                        "Kode": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].kode,
                                        "Kegiatan": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].nmpaket || '',
                                        "Target": isitarget + " " + isivolume,
                                        "Lokasi": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].nmlokasi || '',
                                        "Jenis": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].nmkategori || '',
                                        "MetodePilih": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].nmmetode || '',
                                        "KodeProyek": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].proyeks[0] || '',
                                        "KodeRegister": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].registers[0] || '',
                                        "KodeKKPN": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].kdkppns[0] || '',
                                        "KodeBeban": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].kdbebans[0] || '',
                                        "Pagu": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].pg || '0',
                                        "Realisasi": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].rtot || '0',
                                        "ProgresKeu": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].keuPrs || '0',
                                        "ProgresFisik": this.datatabel[i].childs[z].childs[c].childs[x].childs[y].fisikPrs || '0',
                                        "Class": "kolomsatker"
                                      })
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  this.halamanloading = false;
                }
              ).catch(error => {
                console.log(error);
                this.halamanloading = false;
                //window.location.replace("/");
              });
            $('#costumModaldisclaimer').modal('show');

          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
  },
  created() {
    this.halamanloading = true;
  },
  beforeMount() {
    this.halamanloading = true;
  },
  mounted() {
    this.halamanloading = true;
    //this.loadpeta();
    document.getElementById('DashboardGrup').className = 'nav-item menu-open';
    document.getElementById('MonitoringGrup').className = 'nav-item menu-close';
    document.getElementById('PaketPipeLineGrup').className = 'nav-item menu-close';
    document.getElementById('PaketKontraktualGrup').className = 'nav-item menu-close';
    document.getElementById('PrognosisGrup').className = 'nav-item menu-close';
    document.getElementById('KendalaGrup').className = 'nav-item menu-close';
    document.getElementById('AWPGrup').className = 'nav-item menu-close';
    document.getElementById('PengecekanGrup').className = 'nav-item menu-close';
    document.getElementById('FormIsianGrup').className = 'nav-item menu-close';
    document.getElementById('KompilasiGrup').className = 'nav-item menu-close';
    document.getElementById('ADKGrup').className = 'nav-item menu-close';
    document.getElementById('ManajemenGrup').className = 'nav-item menu-close';
    document.getElementById('bodyLMS').className = 'hold-transition sidebar-mini sidebar-collapse  layout-fixed';
    const sidebar = document.querySelector('aside');
    sidebar.style.display = 'block';
    const nav = document.querySelector('nav');
    nav.style.visibility = 'visible';
    //document.getElementById('Atas').style.visibility = 'visible';
    const footer = document.querySelector('footer');
    footer.style.visibility = 'visible';
    //this.halamanloading = false;

  },
};
</script>

<style></style>
